
// ==============================
// 🚀 GLOBAL SWATCH ENGINE
// ==============================

console.log('🚀 Swatch Engine Loaded');

// ✅ Global cache
window.SwatchStore = {};

// ✅ Helper: detect transparent
function isTransparent(hex) {
  if (!hex) return true;
  return hex.replace(/\s/g, '').toLowerCase() === 'rgba(0,0,0,0)';
}

// ==============================
// 📡 FETCH + CACHE FUNCTION
// ==============================
async function fetchSwatches(prodUrl) {
  prodUrl = prodUrl.split('?')[0];
  if (!prodUrl) return {};

  // ✅ Return from cache
  if (window.SwatchStore[prodUrl]) {
    return window.SwatchStore[prodUrl];
  }

  try {
    const res = await fetch(`${prodUrl}?view=swatches`);
    const text = await res.text();

    let data = JSON.parse(text);

    // 🔥 Fix double JSON
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }

    const swatches = data.swatches || {};

    // ✅ Normalize keys (lowercase)
    const normalized = {};
    Object.keys(swatches).forEach(key => {
      normalized[key.toLowerCase()] = swatches[key];
    });

    // ✅ Save to global cache
    window.SwatchStore[prodUrl] = normalized;

    return normalized;

  } catch (err) {
    console.error('❌ Swatch fetch error:', prodUrl, err);
    return {};
  }
}

// ==============================
// 🎨 APPLY SWATCHES FUNCTION
// ==============================
async function applySwatches(container = document) {

  const links = container.querySelectorAll('.collecton-swatches-wrap a');

  for (let link of links) {

    const prodUrl = link.dataset.produrl;
    const tooltip = link.getAttribute('tooltip');

    if (!prodUrl || !tooltip) continue;

    const colorKey = tooltip.toLowerCase().trim();

    const swatches = await fetchSwatches(prodUrl);

    if (!swatches[colorKey]) continue;

    const { hex, src } = swatches[colorKey];

    // ✅ Apply HEX
    if (!isTransparent(hex)) {
      link.style.backgroundColor = hex;
      link.style.backgroundImage = 'none';
    } 
    // ✅ Apply Image
    else if (src) {
      // link.style.backgroundImage = `url(${src})`;
      // link.style.backgroundSize = 'cover';
      // link.style.backgroundPosition = 'center';
      // link.style.backgroundColor = 'transparent';
        link.style.backgroundColor = 'transparent';
        link.style.backgroundImage = 'none';
    }
  }
}

// ==============================
// ⚡ OPTIONAL: PRELOAD FUNCTION
// ==============================
async function preloadSwatches(container = document) {

  const urls = new Set();

  container.querySelectorAll('.collecton-swatches-wrap a').forEach(link => {
    if (link.dataset.produrl) {
      urls.add(link.dataset.produrl);
    }
  });

  console.log('📦 Preloading swatches for', urls.size, 'products');

  await Promise.all([...urls].map(url => fetchSwatches(url)));

  console.log('✅ Preload complete');
}

// ==============================
// 🚀 AUTO INIT (optional)
// ==============================
document.addEventListener('DOMContentLoaded', async () => {
  await preloadSwatches();     // 🔥 load everything once
  applySwatches();             // 🎨 apply everywhere
});
 

document.addEventListener('click', function (e) {
  const link = e.target.closest('.collection-swatches__container-link');
  if (!link) return;

  e.preventDefault();

  const prodUrl = link.dataset.produrl;
  if (!prodUrl) return;
console.log(prodUrl);
  // Find the parent product card wrapper
  const wrapper = link.closest('.cstm-product-card-wrapper');
  if (!wrapper) return;

  // Remove active from all siblings, add to clicked
  const allLinks = link.closest('.collecton-swatches-wrap').querySelectorAll('.collection-swatches__container-link');
  allLinks.forEach(l => l.classList.remove('active'));
  link.classList.add('active');

  // Fetch product JSON
  fetch(`${prodUrl}.json`)
    .then(res => res.json())
    .then(data => {
      const product = data.product;
      const handle = product.handle;
      const title = product.title;
      const price = product.variants[0]?.price || '';
      const images = product.images;

      if (!images || images.length === 0) return;

      const img1 = images[0];
      const img2 = images[1] || images[0]; // fallback to first if no second

      const productPath = `/products/${handle}`;

      // Build srcset for an image src
      function buildSrcset(src) {
        const widths = [165, 360, 533, 720, 940, 1066, 1600];
        return widths
          .map(w => `${src}&width=${w} ${w}w`)
          .join(',');
      }

      const sizes = `(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)`;

      const src1 = img1.src.replace('https:', '');
      const src2 = img2.src.replace('https:', '');

      const newMediaHTML = `
        <div class="media media--transparent media--hover-effect cstm-card-media-area">
          <a href="${productPath}">
            <img
              srcset="${buildSrcset(src1)}"
              src="${src1}&width=533"
              sizes="${sizes}"
              alt="${title}"
              class="motion-reduce"
              width="${img1.width}"
              height="${img1.height}"
            >
            <img
              srcset="${buildSrcset(src2)}"
              src="${src2}&width=533"
              sizes="${sizes}"
              alt="${title}"
              class="motion-reduce"
              loading="lazy"
              width="${img2.width}"
              height="${img2.height}"
            >
          </a>
          <div class="quick-view-btn" data-produrl="${productPath}?view=quick-view">
           <span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6 12H18M12 6V18" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg></span>
          </div>
        </div>
      `;

     // Replace existing media area
const existingMedia = wrapper.querySelector('.cstm-card-media-area');
if (existingMedia) {
  existingMedia.outerHTML = newMediaHTML;
}

// Update title link
const titleLink = wrapper.querySelector('a.cstm-prod-titl-link');
if (titleLink) {
  titleLink.href = productPath;
  titleLink.textContent = title;
  
}

// Get currency code from wrapper
const currCode = wrapper.dataset.currcode || '';

// Update price
const priceEl = wrapper.querySelector('.price__regular .price-item, .price-item--regular');
if (priceEl) {
  priceEl.textContent = `$${parseFloat(price).toFixed(2)} AUD`;
}
var variantId = product.variants[0].id;
console.log("variantId", variantId);
const btn = wrapper?.querySelector('.add-to-cart-wrap .add-to-cart-btn');
if (btn) btn.dataset.variantid = variantId;

    })
    .catch(err => console.error('Failed to fetch product:', err));
});










document.addEventListener('click', function (e) {
  const btn = e.target.closest('.add-to-cart-btn');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.variantid;

  if (!variantId) {
    console.error('Variant ID not found');
    return;
  }

  // Optional: disable button while loading
  btn.classList.add('loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res => res.json())
  .then(data => {
    console.log('Added to cart:', data);

    // OPTIONAL: update cart UI / open drawer / refresh sections
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
  })
  .catch(err => {
    console.error('Error adding to cart:', err);
  })
  .finally(() => {
    btn.classList.remove('loading');
  });
});









// SWATCH CLICK (works for dynamic modal content)
document.addEventListener('click', async function (e) {
  const swatch = e.target.closest('.quick-view-swatch');
  if (!swatch) return;

  e.preventDefault();

  let url = swatch.getAttribute('data-produrl');
  if (!url) return;

  // add ?view=quick-view
  url += '?view=quick-view';

  const modalContent = document.getElementById('qv-content');

  try {
    // optional loader
    modalContent.style.opacity = '0.5';

    const res = await fetch(url);
    const html = await res.text();

    // 🔥 extract ONLY .qv-wrapper from response
    const newWrapper = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.qv-wrapper');

    const currentWrapper = modalContent.querySelector('.qv-wrapper');

    if (newWrapper && currentWrapper) {
      currentWrapper.replaceWith(newWrapper);

   
      setTimeout(() => {
      applySwatches(modalContent);
      }, 500);

    }

    modalContent.style.opacity = '1';

    // 🔥 re-init JS
    initQuickView(modalContent);

  } catch (err) {
    console.error(err);
  }
});






// =======================================





document.addEventListener('DOMContentLoaded', function () {




  let isLoading = false;
  let hasNextPage = true;

  const container = document.querySelector('.ProductGridContainer-wrapper');

  if (!container) return;

  const pagination = container.querySelector('.pagination-wrapper');
if (pagination) {
  pagination.style.display = 'none';
}

  // ✅ Create loader element
  const loader = document.createElement('div');
  loader.className = 'infinite-loader';
  loader.style.textAlign = 'center';
  loader.style.padding = '20px';
  loader.style.display = 'none';
  // loader.innerHTML = 'Loading products...';
  loader.innerHTML = '<svg height="100" width="100"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><radialGradient id="a1" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)"><stop offset="0" stop-color="#010100"></stop><stop offset=".3" stop-color="#010100" stop-opacity=".9"></stop><stop offset=".6" stop-color="#010100" stop-opacity=".6"></stop><stop offset=".8" stop-color="#010100" stop-opacity=".3"></stop><stop offset="1" stop-color="#010100" stop-opacity="0"></stop></radialGradient><circle transform-origin="center" fill="none" stroke="url(#a1)" stroke-width="15" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform></circle><circle transform-origin="center" fill="none" opacity=".2" stroke="#010100" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70"></circle></svg>';

  container.appendChild(loader);

  // 🔍 Get next page URL
  function getNextPageUrl() {
    const current = container.querySelector('.pagination__item--current');
    if (!current) return null;

    const nextLi = current.parentElement.nextElementSibling;

    if (!nextLi) return null;

    const nextLink = nextLi.querySelector('a');

    return nextLink ? nextLink.getAttribute('href') : null;
  }

  // 📡 Fetch & append products
  async function loadMoreProducts() {
    if (isLoading || !hasNextPage) return;

    const nextUrl = getNextPageUrl();

    if (!nextUrl) {
      hasNextPage = false;
      return;
    }

    isLoading = true;
    loader.style.display = 'block'; // ✅ SHOW loader

    try {
      const res = await fetch(nextUrl);
      const htmlText = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');

      const newContainer = doc.querySelector('.ProductGridContainer-wrapper');

      if (!newContainer) {
        hasNextPage = false;
        return;
      }

      // 🧩 Get new products
      const newItems = newContainer.querySelectorAll('.product-grid-ul li');
      const currentGrid = container.querySelector('.product-grid-ul');

      newItems.forEach(item => {
        console.log(item);
        currentGrid.appendChild(item);
      });

      // 🔁 Update pagination
      const newPagination = newContainer.querySelector('.pagination-wrapper');
      const currentPagination = container.querySelector('.pagination-wrapper');

      if (newPagination && currentPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
         applySwatches();   
      } else {
        hasNextPage = false;
      }

    } catch (error) {
      console.error('Error loading products:', error);
    }

    isLoading = false;
    loader.style.display = 'none'; // ✅ HIDE loader
  }

  // 📜 Scroll detection
  // function handleScroll() {
  //   const scrollPosition = window.innerHeight + window.scrollY;
  //   const threshold = document.body.offsetHeight - 300;

  //   if (scrollPosition >= threshold) {
  //     loadMoreProducts();
  //   }
  // }

  // // 🚀 Init scroll listener
  // window.addEventListener('scroll', handleScroll);

  function handleScroll() {
  const scrollPosition = window.innerHeight + window.scrollY;

  // 👉 detect mobile
  const isMobile = window.innerWidth <= 768;

  // 👉 different trigger points
  const offset = isMobile ? 800 : 300; // adjust mobile value if needed

  const threshold = document.body.offsetHeight - offset;

  if (scrollPosition >= threshold) {
    loadMoreProducts();
  }
}

// 🚀 Init scroll listener
window.addEventListener('scroll', handleScroll);
});

// document.addEventListener('DOMContentLoaded', function () {

//   let isLoading = false;
//   let hasNextPage = true;

//   const container = document.querySelector('#ProductGridContainer');

//   if (!container) return;

//   // 🔍 Get next page URL
//   function getNextPageUrl() {
//     const current = container.querySelector('.pagination__item--current');
//     if (!current) return null;

//     const nextLi = current.parentElement.nextElementSibling;

//     if (!nextLi) return null;

//     const nextLink = nextLi.querySelector('a');

//     return nextLink ? nextLink.getAttribute('href') : null;
//   }

//   // 📡 Fetch & append products
//   async function loadMoreProducts() {
//     if (isLoading || !hasNextPage) return;

//     const nextUrl = getNextPageUrl();

//     if (!nextUrl) {
//       hasNextPage = false;
//       return;
//     }

//     isLoading = true;

//     try {
//       const res = await fetch(nextUrl);
//       const htmlText = await res.text();

//       const parser = new DOMParser();
//       const doc = parser.parseFromString(htmlText, 'text/html');

//       const newContainer = doc.querySelector('#ProductGridContainer');

//       if (!newContainer) {
//         hasNextPage = false;
//         return;
//       }

//       // 🧩 Get new products
//       const newItems = newContainer.querySelectorAll('#product-grid li');
//       const currentGrid = container.querySelector('#product-grid');

//       newItems.forEach(item => {
//         currentGrid.appendChild(item);
//       });

//       // 🔁 Update pagination
//       const newPagination = newContainer.querySelector('.pagination-wrapper');
//       const currentPagination = container.querySelector('.pagination-wrapper');

//       if (newPagination && currentPagination) {
//         currentPagination.innerHTML = newPagination.innerHTML;
//       } else {
//         hasNextPage = false;
//       }

//     } catch (error) {
//       console.error('Error loading products:', error);
//     }

//     isLoading = false;
//   }

//   // 📜 Scroll detection
//   function handleScroll() {
//     const scrollPosition = window.innerHeight + window.scrollY;
//     const threshold = document.body.offsetHeight - 300;

//     if (scrollPosition >= threshold) {
//       loadMoreProducts();
//     }
//   }

//   // 🚀 Init scroll listener
//   window.addEventListener('scroll', handleScroll);

// });






  // (function () {
  //   // 🔧 SET YOUR TARGET DATE & TIME HERE
  //   // Format: YYYY-MM-DDTHH:MM:SS
  //   const targetDateTime = "2026-05-16T23:59:00";

  //   function hideElementIfTimePassed() {
  //     const now = new Date();
  //     const target = new Date(targetDateTime);

  //     if (now >= target) {
  //       const elements = document.querySelectorAll(".sales-product-tiles");
  //       elements.forEach(el => {
  //         el.style.display = "none";
  //       });
  //     }
  //   }

  //   // Run on page load
  //   hideElementIfTimePassed();

  //   // Optional: keep checking every 30 seconds
  //   setInterval(hideElementIfTimePassed, 30000);
  // })();
